import type { ICreativeWithMarkableFile } from '../../types'

/**
 * Тип медиа (вертикальное или горизонтальное)
 */
export type MediaType = 'vertical' | 'horizontal' | 'square'

/**
 * Получение URL медиа из креатива
 * Использует markableFile.canvasImageUrl, который уже содержит правильный URL
 * (для фото - url, для видео - video_frame_url)
 *
 * Примечание: markableFile будет доступен после обновления типов в gateway-rest-api
 */
export function getMediaUrlFromCreative(
    creative?: ICreativeWithMarkableFile | null
): string | null {
    return creative?.markableFile?.canvasImageUrl ?? null
}

/**
 * Определение типа медиа на основе соотношения сторон
 * @param width - ширина медиа
 * @param height - высота медиа
 * @returns тип медиа
 */
export function getMediaType(width: number, height: number): MediaType {
    if (width === height) {
        return 'square'
    }
    return width > height ? 'horizontal' : 'vertical'
}
